<template>
  <div
    v-if="webSocketStatus.connectionState !== 'connected'"
    class="printer-controls"
  >
    <printer-calibratrion-modal
      :calibrate="callPrinterCalibrationService"
      :close="closeCalibrationModal"
    />
    <printer-calibration-button      
      :open="openCalibrationModal"
    />
  </div>
</template>

<script>
import notify from '@/api/notification'
import { mapGetters } from 'vuex'

import PrinterCalibrationButton from '@/components/common/calibration/PrinterCalibrationButton'
import PrinterCalibrationModal from '@/components/common/calibration/PrinterCalibrationModal'
import printerService from '@/api/printer'


export default {
  name: 'PrinterCalibratrion',
  components: {
    'printer-calibration-button': PrinterCalibrationButton,
    'printer-calibratrion-modal': PrinterCalibrationModal,
  },
  computed: {
    ...mapGetters(['webSocketStatus'])
  },
  methods: {
    openCalibrationModal () {
      this.$children[0].$refs.printerCalibrationModal.open()
    },
    closeCalibrationModal () {
      this.$children[0].$refs.printerCalibrationModal.close()
    },
    callPrinterCalibrationService (printerModel) {
      this.closeCalibrationModal()
      printerService.calibratePrinter(printerModel).then(response => {
        notify({
          title: 'AVISO:',
          message: 'Iniciando o processo de calibração da impressora…'
        })
      }).catch(error => {
        if (error.response.data) {
          notify({
            title: 'AVISO:',
            message: error.response.data.message
          })
        }
      })

      this.$analytics.pushAnalyticsEvent('ga-event', {
        'category': 'Calibrar Impressora',
        'action': 'Calibragem de impressora modelo - ' + printerModel
      })
    },
  }
}
</script>

<style lang="scss">
.printer-controls {
  float: left;
  display: flex;
  align-items: center;
}
</style>
